<div class="text-primary-400 text-lg">Featured Courses</div>
<!-- <swiper [config]="swiperConfig">
  <ng-template *ngFor="let course of courses" swiperSlide> -->
<ng-container *ngFor="let course of courses">
  <div class="mb-1 text-xl text-white lg:text-3xl">{{ course.title }}</div>
  <div class="text-primary flex items-center">
    <div *ngFor="let i of numberToArray(course.total_rate)">
      <svg-icon src="@assets/images/icons/star-solid.svg" class="h-4 w-4"></svg-icon>
    </div>
    <div class="pl-2 text-white">
      <span class="font-semibold">{{ course.total_rate }}</span>
      <span class="tracking-widest">({{ course.total_reviews }})</span>
    </div>
  </div>
</ng-container>
<!-- </ng-template>
</swiper> -->
<div class="featured-courses-pagination leading-0 mt-4"></div>
